export function isEmptyJSON(obj) {
  for(var i in obj){
    return true;
  }
    return false;
}
